import {ArrowUpRightIcon, CommentIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Label} from '@primer/react'

export function PreviewFeedbackMenu() {
  return (
    <div className="ml-auto">
      <ActionMenu>
        <ActionMenu.Button aria-label="Stacks preview feedback" variant="invisible" size="small">
          <Label variant="success">Preview</Label>
        </ActionMenu.Button>
        <ActionMenu.Overlay>
          <ActionList>
            <ActionList.LinkItem href="https://gh.io/stacks-feedback" target="_blank" rel="noopener noreferrer">
              <ActionList.LeadingVisual>
                <CommentIcon />
              </ActionList.LeadingVisual>
              Give feedback
              <ActionList.TrailingVisual>
                <ArrowUpRightIcon />
              </ActionList.TrailingVisual>
            </ActionList.LinkItem>
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </div>
  )
}
